import * as React from "react";

import { otherIncomeTypes } from "web_modules/underwriter_dashboard/shared";

const { Creatable } = require("react-select");

const incomeTypeOptions = otherIncomeTypes.map(option => ({ label: option, value: option }));

interface IOtherIncomeTypeProps {
  onChange: Function;
  selectedValue: any;
}

class OtherIncomeType extends React.Component<IOtherIncomeTypeProps, any> {
  render() {
    return (
      <Creatable
        name="operator_income_type"
        className="form__additional_income_typee"
        placeholder="Income type"
        options={incomeTypeOptions}
        value={
          this.props.selectedValue in otherIncomeTypes
            ? this.props.selectedValue
            : {
                label: this.props.selectedValue,
                value: this.props.selectedValue,
              }
        }
        onChange={this.props.onChange}
      />
    );
  }
}

export default OtherIncomeType;
